import * as messageService from "../../services/message.service";
import * as vehicleConditionService from '../../services/vehicleCondition.service';


const state = {
    vehicleConditionAll:[],
    vehicleConditionAllActive:[],
};

const getters = {
    gettVehicleConditionAll:state => (state.vehicleConditionAll),
    gettVehicleConditionAllActive:state => (state.vehicleConditionAllActive),
};

const actions = {
    async fetchVehicleConditionAll({ commit } ){
        try {
            const response = await vehicleConditionService.all();
            commit('setVehicleConditionAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchVehicleConditionAllActive({ commit } ){
        try {
            const response = await vehicleConditionService.allActive();
            commit('setVehicleConditionAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setVehicleConditionAll:(state, res) => (
        state.vehicleConditionAll =  res
    ),
    setVehicleConditionAllActive:(state, res) => (
        state.vehicleConditionAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}